import React, { useEffect } from 'react';
import {
  Create,
  SimpleForm,
  TextInput,
  FileInput,
  ImageField,
  required
} from 'react-admin';

function ExponentePodcastCreate() {
  useEffect(() => {
    document.title = 'Crear Exponente de Podcast';
  }, []);

  return (
    <Create>
      <SimpleForm>
        <TextInput source="nombre" validate={[required()]} />
        <TextInput source="empresa" validate={[required()]} />
        <TextInput source="cargo" validate={[required()]} />
        <FileInput
          source='imagen'
          label='Imagen'
          validate={[required()]}
        >
          <ImageField source="src" />
        </FileInput>
      </SimpleForm>
    </Create>
  )
}

export default ExponentePodcastCreate